import { ProductPostingMode } from '@mews/enums';
import { createHandler } from '@mews/std';
import { BusinessComponentsTextKey as TextKey } from './BusinessComponentsTextKey';

export const getProductPostingTextKeyForBookableServices = (value: ProductPostingMode, perTimeUnitKey: Mews.TextKey) =>
    createHandler({
        [ProductPostingMode.Once]: TextKey.ProductPostingModeOnce,
        [ProductPostingMode.PerTimeUnit]: perTimeUnitKey,
    })(value);
